<template>
  <router-link :to="isLoggedIn ? to : ''" @click="handleClick">
    {{ label }}
  </router-link>
</template>

<script>
export default {
  name: 'AuthLink',

  props: {
    to: {
      type: [String, Object],
      default: null,
      required: true,
    },
    label: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    handleClick(e) {
      if (!this.isLoggedIn) {
        e.preventDefault()
        this.changeDialogState({
          dialog: 'accountDrawer',
          val: true,
        })
      }
    },
  },
}
</script>
